import { useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { company, faqs } from '@/mocks/site';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="container-wide">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-primary-500" />
                <span className="label-mono text-primary-600">Questions fréquentes</span>
              </div>
              <h2 className="display-title mt-5 text-4xl md:text-5xl">
                Vous vous demandez
                <br />
                peut-être...
              </h2>
              <p className="mt-5 text-base leading-relaxed text-foreground-600">
                Une question qui ne figure pas ici ? Notre équipe technique répond directement, sans
                intermédiaire.
              </p>
              <div className="mt-8 rounded-lg bg-foreground-950 p-6 text-background-50">
                <p className="label-mono text-primary-400">Ligne directe</p>
                <a
                  href={company.phoneHref}
                  className="mt-2 block font-heading text-2xl uppercase tracking-wide transition-colors hover:text-primary-400"
                >
                  {company.phone}
                </a>
                <Link
                  to="/contact"
                  className="group mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-300"
                >
                  Écrire un message
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </Reveal>
          </div>

          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <Reveal key={faq.question} delay={index * 60}>
                  <div>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-start justify-between gap-6 py-6 text-left"
                    >
                      <span className="flex gap-4">
                        <span className="mt-1 font-label text-[11px] tracking-[0.16em] text-primary-600">
                          0{index + 1}
                        </span>
                        <span className="font-heading text-xl font-semibold uppercase leading-tight text-foreground-950 md:text-2xl">
                          {faq.question}
                        </span>
                      </span>
                      <span
                        className={`mt-1 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                          isOpen
                            ? 'rotate-45 border-primary-500 bg-primary-500 text-background-50'
                            : 'border-background-300 text-foreground-700'
                        }`}
                      >
                        <i className="ri-add-line text-base" />
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-500 ease-smooth ${
                        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="max-w-2xl pb-7 pl-9 text-sm leading-relaxed text-foreground-600">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}